import React from 'react';
import styles from './styles.scss';
import iconSparkleBlack from '../../../../client/resources/images/Sparkle Black.png';
import iconSparkleColor from '../../../../client/resources/images/Sparkle Color.png';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';
import { connect } from 'react-redux';
import { checkEnableFeatureFlag, getEnabledFlagsInConfigApp } from '../../helpers/common';
import { ATTRIBUTE_CONNECTION_AGENT } from '../../helpers/constant';

const AgentButtons = ({
  isProcessing,
  isModifiedByAgent,
  revertedOnce,
  onConnectAgent,
  onRevertToOriginal,
  onUseAgentSuggestion,
  connectAgentMessageButton,
  revertStandardInstructions,
  useAgentSuggestion,
  processingMessage,
  isAgentActionsFeatureEnabled,
  isDisabled
}) => {
  if (!isAgentActionsFeatureEnabled) {
    return null;
  }
  if (isProcessing) {
    return (
      <div className={styles.agentMessageContainer}>
        <img src={iconSparkleColor} alt="Agent icon" className={styles.agentIcon} />
        <span className={styles.agentMessage}>
          {processingMessage}
          <span className={styles.agentSpinner}>
            <CircularProgress size={25} thickness={1} />
          </span>
        </span>
      </div>
    );
  }

  if (!isModifiedByAgent) {
    return (
      <button
        id="agentButton"
        className={isDisabled ? styles.disabledButton : styles.agentButton}
        onClick={onConnectAgent}
        disabled={isDisabled}
      >
        <img src={iconSparkleBlack} alt="Agent icon" className={styles.agentIcon} />
        {connectAgentMessageButton}
      </button>
    );
  }

  return (
    <>
      {!revertedOnce && (
        <button className={styles.revertButton} onClick={onRevertToOriginal}>
          {revertStandardInstructions}
        </button>
      )}
      {revertedOnce && (
        <button className={styles.revertButton} onClick={onUseAgentSuggestion}>
          {useAgentSuggestion}
        </button>
      )}
    </>
  );
};

AgentButtons.propTypes = {
  isProcessing: PropTypes.bool.isRequired,
  isModifiedByAgent: PropTypes.bool.isRequired,
  revertedOnce: PropTypes.bool.isRequired,
  onConnectAgent: PropTypes.func.isRequired,
  onRevertToOriginal: PropTypes.func.isRequired,
  onUseAgentSuggestion: PropTypes.func.isRequired,
  connectAgentMessageButton: PropTypes.string.isRequired,
  revertStandardInstructions: PropTypes.string.isRequired,
  useAgentSuggestion: PropTypes.string.isRequired,
  processingMessage: PropTypes.string.isRequired,
  isAgentActionsFeatureEnabled: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired
};
const mapStateToProps = (state, props) => {
  const enabledFlagsConfigApp = getEnabledFlagsInConfigApp(props, state);
  const isAgentActionsFeatureEnabled = checkEnableFeatureFlag(
    enabledFlagsConfigApp,
    [ATTRIBUTE_CONNECTION_AGENT]
  );

  return {
    isAgentActionsFeatureEnabled,
  };
};
export default connect(mapStateToProps)(AgentButtons);
